import React from "react";

import "./index.scss";
import Marquee from "react-fast-marquee";

// The ticker across the live page. It is the one full-bleed navy band in the
// app, so it takes the rail's colour rather than a fourth blue of its own.
const InfoLine = ({ text = "Welcome to the auction" }) => (
  <Marquee className="au-ticker" gradient={false}>
    <span className="au-ticker-item">{text}</span>
  </Marquee>
);

export default InfoLine;
